import type { ReviewedLibraryIdentity } from './library-identity-types';

export const LIBRARY_WARMUP_02: ReviewedLibraryIdentity[] = [
  {
    "id": "library-ksw-warmup-biceps-release",
    "name": "训练前二头肌松解",
    "group": "warmup",
    "subCategory": "arms",
    "equipment": "foam-roller",
    "pattern": "肱二头肌训练前松解",
    "legacyIds": [
      "ksw-warmup-biceps-release"
    ],
    "sourceId": "course-20261008-ksw-collection-01-07",
    "targetMuscles": [
      "肱二头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-warmup-lower-trap-y",
    "name": "下斜方肌Y字激活",
    "group": "warmup",
    "subCategory": "thoracic",
    "equipment": "bodyweight",
    "pattern": "站姿Y字肩胛上回旋",
    "legacyIds": [
      "ksw-warmup-lower-trap-y"
    ],
    "sourceId": "course-20261008-ksw-collection-01-04",
    "targetMuscles": [
      "斜方肌下部"
    ],
    "evidence": "俯卧与站姿Y字姿态不同，绳索Y字侧平举为力量动作，分别保留"
  },
  {
    "id": "library-ksw-warmup-serratus-activation",
    "name": "前锯肌激活",
    "group": "warmup",
    "subCategory": "chest",
    "equipment": "bodyweight",
    "pattern": "前锯肌肩胛活动",
    "legacyIds": [
      "ksw-warmup-serratus-activation"
    ],
    "sourceId": "course-20261008-four-way-01-02",
    "targetMuscles": [
      "前锯肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-warmup-wrist-activation",
    "name": "手腕活动热身",
    "group": "warmup",
    "subCategory": "arms",
    "equipment": "bodyweight",
    "pattern": "腕关节活动",
    "legacyIds": [
      "ksw-warmup-wrist-activation"
    ],
    "sourceId": "course-20261008-ksw-collection-01-06",
    "targetMuscles": [
      "前臂肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-warmup-band-shoulder-circles",
    "name": "弹力带过头绕肩",
    "group": "warmup",
    "subCategory": "shoulder",
    "equipment": "resistance-band",
    "pattern": "弹力带过头肩关节环绕",
    "legacyIds": [
      "ksw-warmup-band-shoulder-circles"
    ],
    "sourceId": "course-20261008-home-04-01",
    "targetMuscles": [
      "肩袖肌群",
      "三角肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-warmup-thoracic-flexion",
    "name": "胸椎屈曲激活",
    "group": "warmup",
    "subCategory": "thoracic",
    "equipment": "bodyweight",
    "pattern": "胸椎屈曲活动",
    "legacyIds": [
      "ksw-warmup-thoracic-flexion"
    ],
    "sourceId": "course-20261008-ksw-collection-02-04",
    "targetMuscles": [
      "胸椎稳定肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-warmup-thoracic-proprioception",
    "name": "胸椎本体感受激活",
    "group": "warmup",
    "subCategory": "thoracic",
    "equipment": "bodyweight",
    "pattern": "胸椎位置感活动",
    "legacyIds": [
      "ksw-warmup-thoracic-proprioception"
    ],
    "sourceId": "course-20261008-ksw-collection-02-05",
    "targetMuscles": [
      "胸椎稳定肌群",
      "肩胛稳定肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-warmup-dynamic-frog",
    "name": "动态青蛙趴",
    "group": "warmup",
    "subCategory": "hip-leg",
    "equipment": "bodyweight",
    "pattern": "青蛙位髋活动",
    "legacyIds": [
      "ksw-warmup-dynamic-frog"
    ],
    "sourceId": "course-20261008-ksw-collection-03-06",
    "targetMuscles": [
      "髋内收肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-warmup-hip-90-90",
    "name": "髋关节90/90活动",
    "group": "warmup",
    "subCategory": "hip-leg",
    "equipment": "bodyweight",
    "pattern": "90/90髋内外旋活动",
    "legacyIds": [
      "ksw-warmup-hip-90-90"
    ],
    "sourceId": "course-20261008-ksw-collection-03-08",
    "targetMuscles": [
      "髋部内外旋肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-warmup-ankle-activation",
    "name": "脚踝活动热身",
    "group": "warmup",
    "subCategory": "hip-leg",
    "equipment": "bodyweight",
    "pattern": "踝关节活动",
    "legacyIds": [
      "ksw-warmup-ankle-activation"
    ],
    "sourceId": "course-20261008-ksw-collection-03-09",
    "targetMuscles": [
      "踝关节周围肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-warmup-foam-calf",
    "name": "训练前泡沫轴松解·小腿",
    "group": "warmup",
    "subCategory": "hip-leg",
    "equipment": "foam-roller",
    "pattern": "小腿训练前滚压松解",
    "legacyIds": [
      "ksw-warmup-foam-calf"
    ],
    "sourceId": "course-20261008-ksw-collection-03-03",
    "targetMuscles": [
      "腓肠肌",
      "比目鱼肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-warmup-foam-quad",
    "name": "训练前泡沫轴松解·股四头",
    "group": "warmup",
    "subCategory": "hip-leg",
    "equipment": "foam-roller",
    "pattern": "股四头训练前滚压松解",
    "legacyIds": [
      "ksw-warmup-foam-quad"
    ],
    "sourceId": "course-20261008-ksw-collection-03-02",
    "targetMuscles": [
      "股四头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  }
];
